import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { NiceSimRegistrationRequestModel } from "features/niceSimRegistration/data/model/NiceSimRegistrationRequestModel";
import { NiceSimRegistrationResponseModel } from "features/niceSimRegistration/data/model/NiceSimRegistrationResponseModel";
import { INiceSimRegistrationRepository } from "features/niceSimRegistration/domain/repositories/INiceSimRegistrationRepository";

@injectable()
export class NiceSimRegistrationImpl implements INiceSimRegistrationRepository {
  async getList(
    params: NiceSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    const queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes(""),
      )
      ?.map(([keys, vals]) => StringFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    return await client?.get(
      `${TRANSACTION_HISTORY.NICESIMLIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params,
    );
  }

  async getDetail(
    params: NiceSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    return await client.get(`${TRANSACTION_HISTORY.NICESIMLIST}/${params?.code}`);
  }

  async exportReport(
    params: NiceSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const queryString = Object?.entries(params)
      ?.filter(
        ([_, vals]) =>
          Array.isArray(vals) && !isEmpty(vals) && !vals?.includes(""),
      )
      ?.map(([keys, vals]) => StringFormat.getQueryString(vals, keys))
      ?.join("&");
    DataFormat.removeArrayTypeValue(params);
    const queryParams = new URLSearchParams(
      params as unknown as URLSearchParams,
    )?.toString();
    const url = `${TRANSACTION_HISTORY.NICESIMLIST}${
      !isEmpty(queryString) ? `?${queryString}` : ""
    }${isEmpty(queryString) ? `?${queryParams}` : `&${queryParams}`}`;
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async checkStatus(
    code: string,
  ): Promise<BaseApiResponseModel<NiceSimRegistrationResponseModel>> {
    return await client?.get(APP_TRANSACTION?.CHECK_STATUS, { code });
  }
}
